import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-result-found',
  templateUrl: './not-result-found.component.html'
})
export class NotResultFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
